<div *ngIf="showLoading" class="wbs-overlay" role="status" aria-live="polite">
  <div class="wbs-loader wbs-loader--constellation">
    <div class="wbs-orbit wbs-orbit--a"></div>
    <div class="wbs-orbit wbs-orbit--b"></div>
    <div class="wbs-orbit wbs-orbit--c"></div>

    <div class="wbs-core"></div>

    <div class="wbs-dots">
      <span class="wbs-dot"></span><span class="wbs-dot"></span><span class="wbs-dot"></span>
      <span class="wbs-dot"></span><span class="wbs-dot"></span><span class="wbs-dot"></span>
      <span class="wbs-dot"></span><span class="wbs-dot"></span><span class="wbs-dot"></span>
      <span class="wbs-dot"></span><span class="wbs-dot"></span><span class="wbs-dot"></span>
    </div>

    <p class="wbs-title">{{ selectedTitle }}</p>
    <p class="wbs-subtitle">{{ selectedSubtitle }}</p>
  </div>
</div>
